export default __webpack_public_path__ + "images/pages/quiz/attach-833d4c6a9d32bca4f297b84883817d85.svg";